export const PO_BREAKDOWN_LABELS = [
  "Draft",
  "Approval In Progress",
  "Approved",
  "Rejected",
  "Reconsider",
  "Open POs",
  "Closed POs",
];

export const VENDOR_PO_BREAKDOWN_LABELS = ["Approved POs"];

export const GRN_BREAKDOWN_LABELS = [
  "Draft",
  "Vendor Made GRN",
  "Approval In Progress",
  "Approved",
  "Rejected",
  "Reconsider",
];

export const BUDGET_BREAKDOWN_LABELS = ["Approved", "Pending", "On Hold"];

export const PR_BREAKDOWN_LABELS = [
  "Approval In Progress",
  "Approved",
  "Rejected",
  "PO Released",
  "Pending PO Creation",
];

export const ADVANCE_PAYMENT_BREAKDOWN_LABELS = [
  "Approval In Progress",
  "Approved",
  "Reconsider",
  "Rejected",
];

export const MY_PENDING_ACTIONS_BREAKDOWN_LABELS = ["Awaiting Approval"];

const toBreakdown = (labels) =>
  labels.map((label) => ({
    label,
    value: null,
  }));

const buildPlainCard = ({ tabValue, label, description }) => ({
  tabValue,
  label,
  description,
  type: "plain",
  statusBreakdown: null,
});

export const buildDashboardCards = ({ branch, user, masterRole }) => {
  if (branch === "finance") {
    const cards = [
      {
        tabValue: 0,
        label: "My Pending Actions",
        description: "Track and act on requests awaiting your approval.",
        statusBreakdown: toBreakdown(MY_PENDING_ACTIONS_BREAKDOWN_LABELS),
      },
      {
        tabValue: 1,
        label: "Budgets",
        description: "Create and track site budgets.",
        statusBreakdown: toBreakdown(BUDGET_BREAKDOWN_LABELS),
      },
      {
        tabValue: 2,
        label: "PR",
        description: "Raise and track purchase requisitions.",
        statusBreakdown: toBreakdown(PR_BREAKDOWN_LABELS),
      },
      {
        tabValue: 3,
        label: "PO",
        description: "Create and track purchase orders.",
        statusBreakdown: toBreakdown(PO_BREAKDOWN_LABELS),
      },
      {
        tabValue: 4,
        label: "Goods Receive Notes",
        description: "Record and track goods received against POs.",
        statusBreakdown: toBreakdown(GRN_BREAKDOWN_LABELS),
      },
      {
        tabValue: 5,
        label: "Advance Payment Details",
        description: "Track advance payment invoices.",
        statusBreakdown: toBreakdown(ADVANCE_PAYMENT_BREAKDOWN_LABELS),
      },
      buildPlainCard({
        tabValue: 6,
        label: "Reports",
        description: "View finance reports.",
      }),
    ];

    if (masterRole?.includes("FINANCE") || masterRole?.includes("ADMIN")) {
      cards.push(
        buildPlainCard({
          tabValue: 7,
          label: "Masters",
          description: "Manage vendor and item master data.",
        })
      );
    }

    if (user?.properties?.finance?.approvalConfigRights) {
      cards.push(
        buildPlainCard({
          tabValue: 8,
          label: "Approval Config",
          description: "Configure approval stages and roles.",
        })
      );
    }

    if (user?.properties?.finance?.cfMappingRights) {
      cards.push(
        buildPlainCard({
          tabValue: 9,
          label: "CF Approval Mapping",
          description: "Manage CF approval mapping configuration.",
        })
      );
    }

    return cards;
  }

  if (branch === "vendor") {
    return [
      {
        tabValue: 0,
        label: "PO",
        description: "View purchase orders raised to you.",
        statusBreakdown: toBreakdown(VENDOR_PO_BREAKDOWN_LABELS),
      },
      {
        tabValue: 1,
        label: "Goods Receive Notes",
        description: "Track goods receive notes against the Creator's POs.",
        statusBreakdown: toBreakdown(GRN_BREAKDOWN_LABELS),
      },
      buildPlainCard({
        tabValue: 2,
        label: "Reports",
        description: "View finance reports.",
      }),
    ];
  }

  const cards = [
    {
      tabValue: 0,
      label: "My Pending Actions",
      description: "Track and act on requests awaiting your approval.",
      statusBreakdown: toBreakdown(MY_PENDING_ACTIONS_BREAKDOWN_LABELS),
    },
    {
      tabValue: 1,
      label: "PR",
      description: "Raise and track purchase requisitions.",
      statusBreakdown: toBreakdown(PR_BREAKDOWN_LABELS),
    },
    {
      tabValue: 2,
      label: "PO",
      description: "Create and track purchase orders.",
      statusBreakdown: toBreakdown(PO_BREAKDOWN_LABELS),
    },
    {
      tabValue: 3,
      label: "Goods Receive Notes",
      description: "Record and track goods received against POs.",
      statusBreakdown: toBreakdown(GRN_BREAKDOWN_LABELS),
    },
    {
      tabValue: 4,
      label: "Advance Payment Details",
      description: "Track advance payment invoices.",
      statusBreakdown: toBreakdown(ADVANCE_PAYMENT_BREAKDOWN_LABELS),
    },
    buildPlainCard({
      tabValue: 5,
      label: "Reports",
      description: "View finance reports.",
    }),
  ];

  if (user?.properties?.finance?.approvalConfigRights) {
    cards.push(
      buildPlainCard({
        tabValue: 6,
        label: "Approval Config",
        description: "Configure approval stages and roles.",
      })
    );
  }

  if (user?.properties?.finance?.cfMappingRights) {
    cards.push(
      buildPlainCard({
        tabValue: 7,
        label: "CF Approval Mapping",
        description: "Manage CF approval mapping configuration.",
      })
    );
  }

  // return cards;
  // Plain "user" has no PR access -- drop the PR card (the PR tab is hidden for it too).
  const isBaseUser = (user?.role || "").trim().toUpperCase() === "USER";
  return isBaseUser ? cards.filter((card) => card.label !== "PR") : cards;
};